import { matchPath } from 'react-router-dom';
import { ADMIN, REDIRECT } from './routes';
import data from 'config/base/whitelist.json';
import { getDomain } from '../../utils/route';

export function matchesAnyRoute(path, pathsToCheck) {
  return pathsToCheck.reduce((acc, cv) => {
    const matches = !!matchPath(path, {
      path: cv,
    });
    return matches || acc;
  }, false);
}

export function isTeacherRoute(path) {
  return matchesAnyRoute(path, [ADMIN, REDIRECT]);
}

export function isSafeUrl(url) {
  const el = document.createElement('a');
  el.setAttribute('href', url);

  const safeProtocol = data.protocols.indexOf(el.protocol) !== -1;

  const currentDomain = getDomain(window.location.hostname);
  const newDomain = getDomain(el.hostname);

  const safeDomain =
    newDomain === currentDomain || data.domains.indexOf(newDomain) !== -1;

  return safeProtocol && safeDomain;
}

export function isUrl(url) {
  const el = document.createElement('a');
  el.setAttribute('href', url);
  return !!(el.protocol && el.hostname);
}

export function getFullUrl(url) {
  const el = document.createElement('a');
  el.setAttribute('href', url);
  return el.href;
}
